import { useEffect, useState } from 'react';

export const GAMING_HUB_MODAL_OPEN_ATTRIBUTE = 'data-ghc-modal-open';
export const GAMING_HUB_MODAL_OPEN_EVENT = 'ghc-modal-open-change';

export function isGamingHubModalOpen() {
  if (typeof document === 'undefined') return false;
  return document.body.hasAttribute(GAMING_HUB_MODAL_OPEN_ATTRIBUTE);
}

export function useGamingHubModalOpen() {
  const [open, setOpen] = useState(isGamingHubModalOpen);

  useEffect(() => {
    const updateOpen = () => setOpen(isGamingHubModalOpen());
    const observer = new MutationObserver(updateOpen);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: [GAMING_HUB_MODAL_OPEN_ATTRIBUTE],
    });
    window.addEventListener(GAMING_HUB_MODAL_OPEN_EVENT, updateOpen);
    updateOpen();

    return () => {
      observer.disconnect();
      window.removeEventListener(GAMING_HUB_MODAL_OPEN_EVENT, updateOpen);
    };
  }, []);

  return open;
}
